import fileSaver from 'file-saver'
import xlsx from 'xlsx-style'
import tableHelper from '@/components/sys/Table'
import colorHelper from '@/utils/colorHelper'
import { Loading } from 'element-ui'
import code from '@/components/sys/Code'

// 字符编码转换
function tranFormStrToBuffer (s) {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i !== s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
  return buf
}

// Excel工作簿构造器
function Workbook () {
  if (!(this instanceof Workbook)) return new Workbook()
  this.SheetNames = []
  this.Sheets = {}
}

export default {
  // JS日期转Excel日期格式方法
  tranFormDateToExcel: function (v, date1904) {
    if (date1904) v += 1462
    const epoch = Date.parse(v)
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000)
  },

  // 数组简易转为WorkSheet数据
  arraySimpleToWSData: function (data) {
    const ws = {}
    const range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } }
    for (let R = 0; R !== data.length; R++) {
      for (let C = 0; C !== data[R].length; C++) {
        if (range.s.r > R) range.s.r = R
        if (range.s.c > C) range.s.c = C
        if (range.e.r < R) range.e.r = R
        if (range.e.c < C) range.e.c = C
        const cell = { v: data[R][C] }
        if (cell.v == null) continue
        const cellRef = xlsx.utils.encode_cell({ c: C, r: R })

        if (typeof cell.v === 'number') cell.t = 'n'
        else if (typeof cell.v === 'boolean') cell.t = 'b'
        else if (cell.v instanceof Date) {
          cell.t = 'n'
          cell.z = xlsx.SSF._table[14]
          cell.v = this.tranFormDateToExcel(cell.v)
        } else cell.t = 's'
        ws[cellRef] = cell
        ws[cellRef].s = {
          border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' }
          }
        }
      }
    }
    if (range.s.c < 10000000) ws['!ref'] = xlsx.utils.encode_range(range)
    return ws
  },

  // 导出工作表组到Excel
  exportWssToExcel: function (wss, filename) {
    const wb = new Workbook()
    for (let i = 0; i < wss.length; i++) {
      wb.SheetNames.push(wss[i].sheetName)
      wb.Sheets[wss[i].sheetName] = wss[i].data
    }

    const wbout = xlsx.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' })
    fileSaver.saveAs(new Blob([tranFormStrToBuffer(wbout)], { type: 'application/octet-stream' }), filename + '.xlsx')
  },

  // 导出系统表格数据到Excel
  exportSYSTableToExcel: function (that, tableName, haveTableContent, noShowSummary) {
    that.$confirm('确定将数据导出Excel文件?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      const table = that[tableName]
      const loadingInstance = Loading.service({ fullscreen: true })
      try {
        const getTableContentFnc = that[tableName + 'GetTableContentFnc']
        let tableContentObj = null
        if (haveTableContent) {
          tableContentObj = { error: '000000', tableContent: haveTableContent }
        } else if (getTableContentFnc && typeof getTableContentFnc === 'function') {
          tableContentObj = await getTableContentFnc(100000, 1)
        } else {
          tableContentObj = await tableHelper.getTableContent(table.tableCode, 100000, 1
            , table.orderStr, table.filterStr + (table.customFilterStr ? table.customFilterStr : '')
            , table.detail1FilterStr, table.detail2FilterStr, table.detail3FilterStr)
        }
        if (tableContentObj.error === '000000') {
          const tableContent = tableContentObj.tableContent
          const ws = {}
          const range = {
            s: { c: 0, r: 0 },
            e: { c: table.disPlayColumnInfo.length, r: tableContent.length + 1 }
          }
          const cols = []
          for (let i = 0; i < table.disPlayColumnInfo.length; i++) {
            const cell = { v: table.disPlayColumnInfo[i].ColumnName }
            if (cell.v == null) cell.v = ''
            const cellRef = xlsx.utils.encode_cell({ c: i, r: 0 })
            if (typeof cell.v === 'number') cell.t = 'n'
            else if (typeof cell.v === 'boolean') cell.t = 'b'
            else if (cell.v instanceof Date) {
              cell.t = 'n'
              cell.z = xlsx.SSF._table[14]
              cell.v = this.tranFormDateToExcel(cell.v)
            } else cell.t = 's'
            ws[cellRef] = cell
            ws[cellRef].s = {
              border: {
                top: { style: 'thin' },
                bottom: { style: 'thin' },
                left: { style: 'thin' },
                right: { style: 'thin' }
              },
              font: {
                bold: true
              }
            }
            cols.push({ wch: table.disPlayColumnInfo[i].Width / 8 })
          }
          ws['!cols'] = cols

          const getSpecialStringArray = that[tableName + 'GetSpecialStringArray']
          const getRowStyle = that[tableName + 'RowStyle']

          const spanColumnsArys = []
          const lastHBRC = {}
          if (table.spanColumns && table.spanColumns.length > 0 &&
            table.spanColumnsBasis) {
            for (let t = 0; t < table.spanColumns.length; t++) {
              spanColumnsArys.push([])
              lastHBRC[table.spanColumns[t].name] = 1
            }
          }

          for (let R = 1; R < tableContent.length + 1; R++) {
            let rowBgColor = ''
            if (getRowStyle && typeof (getRowStyle) === 'function') {
              const rowStyle = getRowStyle({ row: tableContent[R - 1], rowIndex: R - 1 })
              rowBgColor = colorHelper.colorToRgb(rowStyle ? rowStyle['background-color'] : '')
            }

            const getCellStyle = that[tableName + 'CellStyle']
            for (let C = 0; C < table.disPlayColumnInfo.length; C++) {
              let cellVal = tableContent[R - 1][table.disPlayColumnInfo[C].ColumnCode]
              if (table.disPlayColumnInfo[C].DataType === '5') {
                if (getSpecialStringArray && typeof (getSpecialStringArray) === 'function') {
                  let specialStringArys = getSpecialStringArray(table.disPlayColumnInfo[C].ColumnCode)
                  if (specialStringArys.length <= 0) {
                    if (table.disPlayColumnInfo[C].DateFormat) {
                      specialStringArys = code.getCode(that.codes, table.disPlayColumnInfo[C].DateFormat)
                    }
                  }
                  for (let i = 0; i < specialStringArys.length; i++) {
                    if (cellVal === specialStringArys[i].code) {
                      cellVal = specialStringArys[i].name
                      break
                    }
                  }
                } else {
                  if (table.disPlayColumnInfo[C].DateFormat) {
                    const specialStringArys = code.getCode(that.codes, table.disPlayColumnInfo[C].DateFormat)
                    for (let i = 0; i < specialStringArys.length; i++) {
                      if (cellVal === specialStringArys[i].code) {
                        cellVal = specialStringArys[i].name
                        break
                      }
                    }
                  }
                }
              }
              const cell = { v: cellVal }
              if (cell.v == null) cell.v = ''
              const cellRef = xlsx.utils.encode_cell({ c: C, r: R })
              if (typeof cell.v === 'number') cell.t = 'n'
              else if (typeof cell.v === 'boolean') cell.t = 'b'
              else if (cell.v instanceof Date) {
                cell.t = 'n'
                cell.z = xlsx.SSF._table[14]
                cell.v = this.tranFormDateToExcel(cell.v)
              } else cell.t = 's'

              let cellBgColor = ''
              if (getCellStyle && typeof (getCellStyle) === 'function') {
                const cellStyle = getCellStyle({
                  row: tableContent[R - 1],
                  column: { property: table.disPlayColumnInfo[C].ColumnCode },
                  rowIndex: R - 1,
                  columnIndex: C
                })
                cellBgColor = colorHelper.colorToRgb(colorHelper.colorToRgb(cellStyle ? cellStyle['background-color'] : ''))
              }
              if (!cellBgColor) {
                cellBgColor = rowBgColor
              }
              let cellRgbColor = ''
              if (cellBgColor.indexOf('#') === 0) {
                cellRgbColor = cellBgColor.substr(1)
              } else {
                cellRgbColor = 'FFFFFF'
              }
              if (table.spanColumns && table.spanColumns.length > 0 &&
                  table.spanColumnsBasis) {
                let needHB = false
                for (let t = 0; t < table.spanColumns.length; t++) {
                  if (R > 1 && table.spanColumns[t].name === table.disPlayColumnInfo[C].ColumnCode) {
                    let hbFlag = true
                    for (let k = 0; k <= table.spanColumnsBasis[table.spanColumns[t].basis].length; k++) {
                      if (tableContent[R - 1][table.spanColumnsBasis[table.spanColumns[t].basis][k]] !==
                          tableContent[R - 2][table.spanColumnsBasis[table.spanColumns[t].basis][k]]) {
                        hbFlag = false
                        break
                      }
                    }
                    needHB = hbFlag
                    if (hbFlag) {
                      if (lastHBRC[table.spanColumns[t].name] === R - 1) {
                        spanColumnsArys[t].push({
                          s: {
                            c: C,
                            r: R - 1
                          },
                          e: {
                            c: C,
                            r: R
                          }
                        })
                      } else {
                        spanColumnsArys[t][spanColumnsArys[t].length - 1].e = {
                          c: C,
                          r: R
                        }
                      }
                    } else {
                      lastHBRC[table.spanColumns[t].name] = R
                    }
                  }
                }
                if (needHB) {
                  cell.v = ''
                }
              }
              ws[cellRef] = cell
              ws[cellRef].s = {
                border: {
                  top: { style: 'thin' },
                  bottom: { style: 'thin' },
                  left: { style: 'thin' },
                  right: { style: 'thin' }
                },
                alignment: {
                  vertical: 'center'
                },
                fill: {
                  fgColor: {
                    rgb: cellRgbColor
                  }
                }
              }
            }
          }

          let merges = []
          for (let i = 0; i < spanColumnsArys.length; i++) {
            merges = merges.concat(spanColumnsArys[i])
          }
          if (merges.length > 0) {
            ws['!merges'] = merges
          }

          if (!noShowSummary && that[tableName + 'Summary'] && typeof (that[tableName + 'Summary']) === 'function') {
            range.e.r = tableContent.length + 2
            const summaryColumns = []
            for (let i = 0; i < table.disPlayColumnInfo.length; i++) {
              summaryColumns.push(Object.assign({}, table.disPlayColumnInfo[i], {
                property: table.disPlayColumnInfo[i].ColumnCode
              }))
            }
            const sums = that[tableName + 'Summary']({ columns: summaryColumns, data: tableContent })
            for (let C = 0; C < sums.length; C++) {
              const cellVal = sums[C]
              const cell = { v: cellVal }
              if (cell.v == null) cell.v = ''
              const cellRef = xlsx.utils.encode_cell({ c: C, r: tableContent.length + 1 })
              if (typeof cell.v === 'number') cell.t = 'n'
              else if (typeof cell.v === 'boolean') cell.t = 'b'
              else if (cell.v instanceof Date) {
                cell.t = 'n'
                cell.z = xlsx.SSF._table[14]
                cell.v = this.tranFormDateToExcel(cell.v)
              } else cell.t = 's'

              ws[cellRef] = cell
              ws[cellRef].s = {
                border: {
                  top: { style: 'thin' },
                  bottom: { style: 'thin' },
                  left: { style: 'thin' },
                  right: { style: 'thin' }
                },
                alignment: {
                  vertical: 'center'
                }
              }
            }
          }
          ws['!ref'] = xlsx.utils.encode_range(range)
          const wss = []
          wss.push({ sheetName: 'sheet1', data: ws })
          this.exportWssToExcel(wss, table.tableInfo.TableName)
        } else {
          that.$message.error(tableContentObj.msg)
        }
      } catch (e) {
        that.$message.error('导出过程出现异常！请联系管理员查看！' + e.toString())
      }
      loadingInstance.close()
    })
  }
}
